import { Action, createReducer, on } from '@ngrx/store';
import { SessionState, initialState } from './session.state';

import Bugsnag from '@bugsnag/js';
import { apiResponse } from '../api/api.actions';
import { validString } from 'src/app/shared/utilities/types.utils';

const reducer = createReducer(
	initialState,
	on(apiResponse, (state, action) => {
		if (!action.isOk) {
			return state;
		}
		const id = action.response.session_id;
		if (validString(id)) {
			const config = Bugsnag.getMetadata('ClientConfig');
			config.sessionId = id;
			Bugsnag.addMetadata('ClientConfig', config);

			return {
				id,
			};
		}
		return state;
	})
);

export function sessionReducer(state: SessionState, action: Action): SessionState {
	return reducer(state, action);
}
